export const placeholderText = (): string => {
  return "Escribe aquí";
};

export const placeholderSelectSimple = (): string => {
  return "Seleccione una opción";
};

export const placeholderNoOptions = (): string => {
  return "No hay opciones para mostrar";
};

export const placeholderSelectFile = (): string => {
  return "Seleccione un archivo";
};

export const placeholderResourceText = (): string => {
  return "Desarrolle su respuesta";
};
